import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card } from 'react-bootstrap';
import { MdDesignServices } from "react-icons/md";

const WhyUsCards = () => {
  const [features, setFeatures] = useState([]);
  const [error, setError] = useState(''); // Initialize as a string

  useEffect(() => {
    // Fetch features from the backend
    const fetchFeatures = async () => {
      try {
        const response = await axios.get('https://zoomautos.co.uk/api/features', {
          
        params: {
          _t: new Date().getTime(), // Add timestamp to bypass cache
        },
      
      }); // Ensure the route is lowercase
        setFeatures(response.data);
      } catch (err) {
        console.error('Error fetching features:', err);
        setError('Failed to fetch features. Please try again later.');
      }
    };

    fetchFeatures();
  }, []);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px', background: '#01103b', marginBottom: '200px' }}>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {features.map((feature, index) => (
        <Card
          key={index}
          style={{
            width: '18rem',
            backgroundColor: 'white',
            boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.09)',
            padding: '2rem',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '8px',
            border: '4px solid #7C3AED',
            minHeight: '30rem',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '20px'
          }}
        >
          <div
            style={{
              width: '6rem',
              height: '6rem',
              backgroundColor: '#7C3AED',
              borderRadius: '50%',
              position: 'absolute',
              top: '-30px',
              right: '-30px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <p style={{ color: 'white', fontSize: '1.5rem' }}>{index + 1}</p>
          </div>
          <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <MdDesignServices size={48} color="#7C3AED" />
          </div>
          <div style={{ flexGrow: 1, textAlign: 'center' }}>
            <Card.Title style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>{feature.title}</Card.Title>
            <Card.Text style={{ color: '#FFFFFF', fontSize: '0.875rem' }}>
              {feature.description}
            </Card.Text>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default WhyUsCards;
